var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m15 21a1 1 0 0 0 1-1v-13.59l2.29 2.3a1 1 0 0 0 1.42-1.42l-4-4a1 1 0 0 0 -1.09-.21 1 1 0 0 0 -.62.92v16a1 1 0 0 0 1 1z",
    fill: "#4080ff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m8.29 20.71a1 1 0 0 0 .71.29.84.84 0 0 0 .38-.08 1 1 0 0 0 .62-.92v-16a1 1 0 0 0 -2 0v13.59l-2.29-2.3a1 1 0 0 0 -1.42 1.42z",
    fill: "#4080ff",
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionRestore);
export default __webpack_public_path__ + "static/media/connection-restore.d347c71deec02bea33310de2cff2c5ed.svg";
export { ForwardRef as ReactComponent };